/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAuthPermissionFromJSON, ApiAuthPermissionToJSON, } from './ApiAuthPermission';
import { ApiStatusFromJSON, ApiStatusToJSON, } from './ApiStatus';
export function ApiAuthUserFromJSON(json) {
    return ApiAuthUserFromJSONTyped(json, false);
}
export function ApiAuthUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !exists(json, 'email') ? undefined : json['email'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'localId': !exists(json, 'localId') ? undefined : json['localId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'permissions': !exists(json, 'permissions') ? undefined : (json['permissions'].map(ApiAuthPermissionFromJSON)),
        'status': !exists(json, 'status') ? undefined : ApiStatusFromJSON(json['status']),
        'tenant': !exists(json, 'tenant') ? undefined : json['tenant'],
        'verifiedAt': !exists(json, 'verifiedAt') ? undefined : (new Date(json['verifiedAt'])),
    };
}
export function ApiAuthUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'id': value.id,
        'localId': value.localId,
        'name': value.name,
        'password': value.password,
        'permissions': value.permissions === undefined ? undefined : (value.permissions.map(ApiAuthPermissionToJSON)),
        'status': ApiStatusToJSON(value.status),
        'tenant': value.tenant,
        'verifiedAt': value.verifiedAt === undefined ? undefined : (value.verifiedAt.toISOString()),
    };
}
